import { RouteType } from 'types/RouteType'; // Adjust the import path as necessary
import databaseManagerRoute from './DatabaseManager/databaseManager.Route';

const adminRoutesList: RouteType[] = [databaseManagerRoute];

export default adminRoutesList;
